import imageDe from '../images/de/sensotrend_dashboard_sharing_link.png';
import imageEn from '../images/en/sensotrend_dashboard_sharing_link.png';
import imageEs from '../images/es/sensotrend_dashboard_sharing_link.png';
import imageFi from '../images/fi/sensotrend_dashboard_sharing_link.png';
import imageFr from '../images/fr/sensotrend_dashboard_sharing_link.png';
import imageIt from '../images/it/sensotrend_dashboard_sharing_link.png';
import imageNo from '../images/no/sensotrend_dashboard_sharing_link.png';
import imageSv from '../images/sv/sensotrend_dashboard_sharing_link.png';

export const dashboardSharingLinkImage = {
  de() {
    return imageDe;
  },
  en() {
    return imageEn;
  },
  es() {
    return imageEs;
  },
  fi() {
    return imageFi;
  },
  fr() {
    return imageFr;
  },
  it() {
    return imageIt;
  },
  no() {
    return imageNo;
  },
  sv() {
    return imageSv;
  },
};
